import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import {deleteSubmittal, getSubmittals} from "../../../actions/submittals";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import SubmittalSummary from "./SubmittalSummary";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr, subdocumentStatusReportSelector, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {compose} from "redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {DeleteButton} from "../DeleteButton";
import UserSmall from "../../Boilerplate/UserSmall";

class SubmittalList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterKeys: null,
      filterActive: false,
      statusFilter: null,
      error: null,
    };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { submittals } = this.props;
      submittals = submittals || [];
      const options = {
        keys: [
          'resource.title',
          'resource.question',
          'resource.response',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(submittals, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  render() {
    let { submittals, project } = this.props;
    submittals = submittals || [];

    const { error } = this.state;
    if (error) return <pre>{error.toString()}</pre>;

    const { filterActive, filterKeys, statusFilter } = this.state;
    if (statusFilter) {
      submittals = submittals.filter(submittals => submittals.resource.status === statusFilter);
    }
    if (filterActive) {
      submittals = submittals.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = submittals.map(i=>i.resource);
    index.sort((a, b) => a.datecreated-b.datecreated);
    index = index.map(i=>i.id);

    return (
      <React.Fragment>
        <Row gutter={16}>
          <Col span={18}>
            <Card>
              <div className='bid-listing-header'>
                <h1>Submittals</h1>
                <SearchBox
                  className='control-box control-search'
                  placeholder='search submittals'
                  onChange={value => this.setFilter(value)}
                />
              </div>
              <Divider/>
              <ExpandedList
                items={submittals}
                index={index}
                derivedKey={item => item.resource.id}
                extra={(<Button type='primary' icon='plus' disabled={!canCreateSub('submittal')(project)} onClick={this.props.onNew}>New Submittal</Button>)}
                subExtra={<div>
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                </div>}
                renderHeading={() => (
                  <Row className='bid-listing-heading text-column'>
                    <Col span={10}>Submittal</Col>
                    <Col span={3}>Created Date</Col>
                    <Col span={6}>Due Date</Col>
                    <Col span={5}>Status</Col>
                  </Row>
                )}
                renderTop={submittal => {
                  let options = [];
                  if (canDelete(submittal)) options.push(<DeleteButton fauxKey={'delete-' + submittal.resource.id} icon='delete'
                    title='Delete Submittal' document={submittal} onDelete={this.props.onDelete} type='submittal'/>);
                  return (
                    <Row justify='space-between'>
                      <Col span={10}>
                        <NavLink key={1} to={submittal.resource.id}>{submittal.resource.title}</NavLink>
                      </Col>
                      <Col span={3}>
                        <DateDisplay date={submittal.resource.datecreated}/>
                      </Col>
                      <Col span={6}>
                        <DateDisplay date={submittal.resource.duedate}/>
                      </Col>
                      <Col span={2}>
                        <CodeTag
                          code={submittal.resource.status}
                          table={'submittalstatus'}
                          onClick={() => this.setFilterCode(submittal.resource.status)}
                        />
                      </Col>
                      <Col span={3}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <div>
                            {separatorJoin(options, <span> | </span>)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  );
                }}
                renderContent={submittal => (
                  <React.Fragment>
                    <p>{submittal.resource.description}</p>
                    <p>Created by <UserSmall id={submittal.resource.createdbyuserid}/>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Assigned to <UserSmall id={submittal.resource.owneruserid}/></p>
                  </React.Fragment>
                )}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <SubmittalSummary
                title='Submittals by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

SubmittalList.propTypes = {
  submittals: PropTypes.arrayOf(PropTypes.object),
  statusSummary: PropTypes.array.isRequired,
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'submittals'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const submittals = subViewSelector(state, props);
      const statusSummary = subdocumentStatusReportSelector(state, { path: 'submittals', code: 'submittalstatus' });
      return { submittals, statusSummary, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'submittals']));
        dispatch(getSubmittals(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/submittals/new`),
      onDelete: (submittalId) => dispatch(deleteSubmittal(props.match.params.id, submittalId)),
    })),
  withLoading
)(SubmittalList);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalList.js